import { queryDictionary } from '@/api/base';
import { getRoleList } from '@/api/setting/setting';
import { queryPage } from '@/api/operation-manage/carrier';
import { queryPage as equipmentQueryPage } from '@/api/etc-equipment-manage/equipment';
import { queryPage as cardQueryPage } from '@/api/etc-equipment-manage/card';

export default {
    // 字典名称搜索
    dictionary: {
        method: queryDictionary,
        label: 'name',
        value: 'id',
    },
    // 角色列表
    roles: {
        method: getRoleList,
        label: 'name',
        value: 'id',
    },
    // 承运商列表
    carriers: {
        method: queryPage,
        label: 'carrierUnitName',
        value: 'carrierUnitId',
    },
    // 承运商列表
    carriersName: {
        method: queryPage,
        label: 'carrierUnitName',
        value: 'carrierUnitName',
    },
    // 设备列表
    device: {
        method: equipmentQueryPage,
        label: 'initialObuContractNo',
        value: 'initialObuContractNo',
    },
    // 卡片列表
    card: {
        method: cardQueryPage,
        label: 'initialCardContractNo',
        value: 'initialCardContractNo',
    },
};
